<template>

    <div class="c-tabs">
        <span v-if="dateTime" class="c-tabs__date"><strong>{{ date }}</strong> {{ time }}</span>
        <tabs-nav :end-btn-label="endBtnLabel" :end-btn-hint="endBtnHint" class="c-tabs__nav"></tabs-nav>
        <div class="c-tabs__tabs" id="tab-container">
            <div class="c-tabs__tabs-inner">
                <slot></slot>
            </div>
        </div>
    </div>

</template>


<script>

import TabsNav from './TabsNav'
import moment from 'moment'

export default {

    name: 'TabsMain',

    props: {
        endBtnLabel: String,
        endBtnHint: String,
        value: {
            type: [String, Number],
            default: 0
        },
        dateTime: [String, Object],
        validator: Object,
        specificNav: Boolean
    },

    data() {
        return {
            isLoading: false,
            activeTab: parseInt(this.value),
            tabItems: []
        }
    },

    computed: {
        date() {
            return moment(this.dateTime).format('DD.MM.YYYY')
        },
        time() {
            return moment(this.dateTime).format('HH:mm')
        }
    },

    watch: {
        value(value) {
            this.changeTab(value)
        },
        tabItems() {
            if (this.tabItems.length)
                this.tabItems[this.activeTab].isActive = true
        }
    },

    methods: {
        changeTab(newIndex) {
            if (this.activeTab === newIndex) return

            this.tabItems[this.activeTab].deactivate(this.activeTab, newIndex)
            this.tabItems[newIndex].activate(this.activeTab, newIndex)
            this.activeTab = newIndex
            this.$emit('change', newIndex)
        },
        validateAllTabs() {
            let validations = [];
            const len = this.tabItems.length
            for (let i = 0; i < len; i++) {
                validations.push(this.tabItems[i].checkValid())
            }
            return Promise.all(validations).then(results => results.every(r => r))
        },
        saveForm() {
            this.isLoading = true
            this.validateAllTabs().then((isValid) => {
                if (isValid) {

                    this.$emit('submit', () => {
                        this.isLoading = false
                    })
                } else {
                    this.isLoading = false
                    this.$emit('submit-error')
                }
            })
        }
    },

    mounted() {
        if (this.tabItems.length) {
            this.tabItems[this.activeTab].isActive = true
        }
    },

    components: {
        TabsNav
    }

}
</script>
<style lang="scss">

@import '~Style/_utils.scss';

.c-tabs {
    width: 100%;
    display: flex;

    &__date {
        position: absolute;
        top: 0;
        right: 0;
        background-color: $c-border;
        color: #9FA9BA;
        padding: .5rem 1rem;
        font-size: 0.8rem;
        z-index: 3;

        strong {
            font-weight: 600;
        }
    }
    &__tabs {
        position: relative;
        flex-grow: 999;
        outline: 1px solid $c-border;
        overflow: hidden;

        &-inner {
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
    @include bp($screen-xl) {
        flex-direction: column;

        &__tabs-inner {
            position: static;
            height: auto;
        }
    }
    @include bp($screen-sm) {
        &__tab {
            padding: 20px;
        }
    }
}

</style>
